export default class SearchDropdown {

    constructor() {
        
        this.settings = {
            $searchIcon : $('.js-search-icon')
        };
        
        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$searchIcon != null ) {
            this.settings.$searchIcon.on('click', () => {
                const $dropdown = $('.js-search-dropdown').toggleClass('hidden');

                if (!$dropdown.hasClass('hidden')) {
                    $dropdown.find('.search-input').trigger('focus');
                }
            });

            $('.js-search-close').on('click', () => {
                $('.js-search-dropdown').addClass('hidden');
            });
        }

    }
};

new SearchDropdown();